import { render, staticRenderFns } from "./BagSummary.vue?vue&type=template&id=1a21e216&"
import script from "./BagSummary.vue?vue&type=script&lang=js&"
export * from "./BagSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports